import { onBeforeUnmount, ref } from "vue";
import { getRatingContext } from "@/services/api";
import { normalizeRatingRow } from "@/utils/player";

/** Neighbours use the server's authoritative ranking, including positions beyond the top 100. */
export function useRatingContext(session, radius = 1) {
  const mine = ref(null);
  const nearby = ref([]);
  const loading = ref(true);
  const error = ref("");
  let request = 0;
  let disposed = false;

  async function load() {
    const current = ++request;
    loading.value = true;
    error.value = "";
    try {
      const response = await getRatingContext(radius);
      if (disposed || current !== request) return;
      // No index fallback: absent positions must never become invented positions 1, 2, 3.
      mine.value = normalizeRatingRow(response && response.me);
      nearby.value = (Array.isArray(response && response.nearby) ? response.nearby : [])
        .map((row) => normalizeRatingRow(row))
        .filter((row) => row && row.rank !== null);
      session.myRating = mine.value;
    } catch (failure) {
      if (disposed || current !== request) return;
      mine.value = null;
      nearby.value = [];
      error.value = (failure && failure.message) || "Не удалось загрузить рейтинг";
    } finally {
      if (!disposed && current === request) loading.value = false;
    }
  }

  onBeforeUnmount(() => { disposed = true; request += 1; });
  return { mine, nearby, loading, error, load };
}
